import { all, fork, call, put, takeLatest, take } from 'redux-saga/effects'

import { constants } from '../modules/vehiclesActions'
import { constants as scheduledDeliveryConstants } from '../modules/scheduledDeliveriesActions'
import * as api from '../api/vehicle'

function* fetchVehicles(action) {
  try {
    const payload = yield call(api.getVehiclesList, action)
    yield put({ type: constants.VEHICLES_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.VEHICLES_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* createVehicle(action) {
  try {
    const payload = {
      content: action.content
    }
    yield call(api.createVehicle, payload)
    yield put({ type: constants.CREATE_VEHICLE.SUCCESS, payload })
    yield call(fetchVehicles)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_VEHICLE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateVehicle() {
  yield takeLatest(constants.CREATE_VEHICLE.ACTION, createVehicle)
}

function* editVehicle(action) {
  try {
    const payload = {
      content: action.content,
      vehicleId: action.vehicleId
    }
    yield call(api.editVehicle, payload)
    yield put({ type: constants.EDIT_VEHICLE.SUCCESS, payload })
    yield call(fetchVehicles)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EDIT_VEHICLE.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditVehicle() {
  yield takeLatest(constants.EDIT_VEHICLE.ACTION, editVehicle)
}

function* deleteVehicle(action) {
  try {
    const payload = {
      vehicleId: action.vehicleId
    }
    yield call(api.deleteVehicle, payload)
    yield put({ type: constants.DELETE_VEHICLE.SUCCESS, payload })
    yield call(fetchVehicles)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_VEHICLE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteVehicle() {
  yield takeLatest(constants.DELETE_VEHICLE.ACTION, deleteVehicle)
}

function* editVehicleStatus(action) {
  try {
    const payload = {
      content: action.content,
      vehicleId: action.vehicleId
    }
    yield call(api.editVehicleStatus, payload)
    yield put({ type: constants.EDIT_VEHICLE_STATUS.SUCCESS, payload })
    yield call(fetchVehicles)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EDIT_VEHICLE_STATUS.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditVehicleStatus() {
  yield takeLatest(constants.EDIT_VEHICLE_STATUS.ACTION, editVehicleStatus)
}

// ATTACHMENT SAGAS
function* uploadAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      vehicleId: action.vehicleId
    }

    yield call(api.uploadAttachments, payload)
    yield put({ type: constants.UPLOAD_VEHICLE_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { vehicleId: action.vehicleId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_VEHICLE_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadAttachments() {
  yield takeLatest(constants.UPLOAD_VEHICLE_ATTACHMENT.ACTION, uploadAttachments)
}

function* getAttachments(action) {
  try {
    const payload = yield call(api.getAttachments, action.vehicleId)
    yield put({ type: constants.GET_VEHICLE_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_VEHICLE_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAttachments() {
  yield takeLatest(constants.GET_VEHICLE_ATTACHMENTS.ACTION, getAttachments)
}

function* updateAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      user_id: 1,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_VEHICLE_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getAttachments, { vehicleId: action.vehicleId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_VEHICLE_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_VEHICLE_ATTACHMENT_DESCRIPTION.ACTION,
    updateAttachmentDescription
  )
}

function* deleteAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      vehicleId: action.vehicleId
    }

    yield call(api.deleteAttachment, payload)
    yield put({ type: constants.DELETE_VEHICLE_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { vehicleId: action.vehicleId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_VEHICLE_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteAttachments() {
  yield takeLatest(constants.DELETE_VEHICLE_ATTACHMENT.ACTION, deleteAttachment)
}

// notes
function* fetchVehicleNote(action) {
  try {
    const payload = yield call(api.fetchVehicleNote, { vehicleId: action.vehicleId })
    yield put({ type: constants.GET_VEHICLE_NOTE.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_VEHICLE_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchVehicleNote() {
  yield takeLatest(constants.GET_VEHICLE_NOTE.ACTION, fetchVehicleNote)
}

function* createVehicleNote(action) {
  try {
    const payload = {
      content: action.content,
      vehicleId: action.vehicleId
    }
    yield call(api.createVehicleNote, payload)
    yield put({ type: constants.CREATE_VEHICLE_NOTE.SUCCESS, payload })
    yield call(fetchVehicleNote, { vehicleId: action.vehicleId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_VEHICLE_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateVehicleNote() {
  yield takeLatest(constants.CREATE_VEHICLE_NOTE.ACTION, createVehicleNote)
}

function* editVehicleNote(action) {
  try {
    const payload = {
      content: action.content,
      noteId: action.noteId
    }
    yield call(api.editVehicleNote, payload)
    yield put({ type: constants.EDIT_VEHICLE_NOTE.SUCCESS, payload })
    yield call(fetchVehicleNote, { vehicleId: action.vehicleId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EDIT_VEHICLE_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditVehicleNote() {
  yield takeLatest(constants.EDIT_VEHICLE_NOTE.ACTION, editVehicleNote)
}

function* deleteVehicleNote(action) {
  try {
    const payload = {
      noteId: action.noteId
    }
    yield call(api.deleteVehicleNote, payload)
    yield put({ type: constants.DELETE_VEHICLE_NOTE.SUCCESS, payload })
    yield call(fetchVehicleNote, { vehicleId: action.vehicleId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_VEHICLE_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteVehicleNote() {
  yield takeLatest(constants.DELETE_VEHICLE_NOTE.ACTION, deleteVehicleNote)
}

// followUps
function* fetchVehicleFollowUp(action) {
  try {
    const payload = yield call(api.fetchVehicleFollowUp, { vehicleId: action.vehicleId })
    yield put({ type: constants.GET_VEHICLE_FOLLOW_UP.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_VEHICLE_FOLLOW_UP.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchVehicleFollowUp() {
  yield takeLatest(constants.GET_VEHICLE_FOLLOW_UP.ACTION, fetchVehicleFollowUp)
}

function* createVehicleFollowUp(action) {
  try {
    const payload = {
      content: action.content,
      vehicleId: action.vehicleId
    }
    yield call(api.createVehicleFollowUp, payload)
    yield put({ type: constants.CREATE_VEHICLE_FOLLOW_UP.SUCCESS, payload })
    yield call(fetchVehicleFollowUp, { vehicleId: action.vehicleId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_VEHICLE_FOLLOW_UP.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateVehicleFollowUp() {
  yield takeLatest(constants.CREATE_VEHICLE_FOLLOW_UP.ACTION, createVehicleFollowUp)
}

function* editVehicleFollowUp(action) {
  try {
    const payload = {
      content: action.content,
      followUpId: action.followUpId
    }
    yield call(api.editVehicleFollowUp, payload)
    yield put({ type: constants.EDIT_VEHICLE_FOLLOW_UP.SUCCESS, payload })
    yield call(fetchVehicleFollowUp, { vehicleId: action.vehicleId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EDIT_VEHICLE_FOLLOW_UP.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditVehicleFollowUp() {
  yield takeLatest(constants.EDIT_VEHICLE_FOLLOW_UP.ACTION, editVehicleFollowUp)
}

function* deleteVehicleFollowUp(action) {
  try {
    const payload = {
      followUpId: action.followUpId
    }
    yield call(api.deleteVehicleFollowUp, payload)
    yield put({ type: constants.DELETE_VEHICLE_FOLLOW_UP.SUCCESS, payload })
    yield call(fetchVehicleFollowUp, { vehicleId: action.vehicleId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_VEHICLE_FOLLOW_UP.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteVehicleFollowUp() {
  yield takeLatest(constants.DELETE_VEHICLE_FOLLOW_UP.ACTION, deleteVehicleFollowUp)
}

function* fetchScheduledDeliveries(action) {
  try {
    const payload = yield call(api.getScheduledDeliveries, action.vehicleId)
    yield put({ type: constants.FETCH_SCHEDULED_DELIVERIES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.FETCH_SCHEDULED_DELIVERIES.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchVehicleDeliveries() {
  yield takeLatest(constants.FETCH_SCHEDULED_DELIVERIES.ACTION, fetchScheduledDeliveries)
}

function* watchDeleteVehicleDeliveries() {
  while (true) {
    const action = yield take(scheduledDeliveryConstants.SCHEDULED_DELIVERIES_DELETE.SUCCESS)
    yield call(fetchScheduledDeliveries, { vehicleId: action.deleted.data.vehicle_id })
  }
}

/**
 * Saga
 */
function* vehiclesRefresh() {
  yield takeLatest(constants.VEHICLES_REFRESH.ACTION, fetchVehicles)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(vehiclesRefresh),
    fork(watchCreateVehicle),
    fork(watchEditVehicle),
    fork(watchDeleteVehicle),
    fork(watchEditVehicleStatus),

    fork(watchUploadAttachments),
    fork(watchGetAttachments),
    fork(watchUpdateAttachmentDescription),
    fork(watchDeleteAttachments),

    fork(watchFetchVehicleNote),
    fork(watchCreateVehicleNote),
    fork(watchEditVehicleNote),
    fork(watchDeleteVehicleNote),

    fork(watchFetchVehicleFollowUp),
    fork(watchCreateVehicleFollowUp),
    fork(watchEditVehicleFollowUp),
    fork(watchDeleteVehicleFollowUp),

    fork(watchFetchVehicleDeliveries),
    fork(watchDeleteVehicleDeliveries)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/vehiclesSaga.js